import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import apiUrl from '../Apiurl';
import stilePulsanti from '../interfaccia/stilePulsanti';
import apriUrl from '../interfaccia/funzioniComuni/apriUrl';

function ExportCSV({soloTasto}) {

    const { user, /* isAuthenticated,  */getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");

    useEffect(() => {
        const getUserMetadata = async () => {

            try {
                const accessToken = await getAccessTokenSilently();
                setToken(accessToken);
            } catch (e) {
                console.log(e.message);
            }
        };

        getUserMetadata();


    }, [getAccessTokenSilently, user?.sub]);


    function esportaCSV() {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }

        fetch(apiUrl + "/prodotti/exportCSV", { headers: { Authorization: "Bearer " + token } })
            .then(resp => resp.json())
            .then(data => apriUrl(data))
    }

    if (soloTasto !== "s") {
        return (
            <section className="ph3 ph5-ns pv5">
                <article className="mw8 center br2 ba b--light-blue bg-lightest-blue">
                    <div className="dt-ns dt--fixed-ns w-100">
                        <div className="pa3 pa4-ns dtc-ns v-mid">
                            <div>
                                <h2 className="fw4 blue mt0 mb3">Esportazione traduzioni</h2>
                                <p className="black-70 measure lh-copy mv0">
                                    Clicca per esportare un csv di tutti i prodotti tradotti non ancora esportati.
                                </p>
                            </div>
                        </div>
                        <div className="pa3 pa4-ns dtc-ns v-mid">
                            <button onClick={esportaCSV} className="no-underline pointer f6 tc db w-100 pv3 bg-animate b--blue bg-blue hover-bg-dark-blue white br2">Esporta CSV</button>
                        </div>
                    </div>
                </article>
            </section>
        );
    } else {
        return (
            <div className='tc pa4'>
            <button onClick={esportaCSV} className={stilePulsanti.buttonClassesWhite}>Esporta CSV</button>
            </div>
                        
        );
    }

    
};

export default ExportCSV;
